import { Button, Card, notification, Space, Table } from "antd";
import { useEffect, useState } from "react";

import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";
import { DELETE, POST } from "../../utils/apicalls";

import { DeleteOutlined } from "@ant-design/icons";
import PageHeader from "../../admin/pageHeader/pageheader";

function InvoiceIndexHR() {
  const navigate = useNavigate();

  const [data, setData] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const [meta, setMeta] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const fetchInvoice = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: "query",
        page: page,
        take: 20,
      };
      const url = API.LIST_INVOICE;
      const response: any = await POST(url, obj);
      setData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchInvoice(page, pageSize);
  }, [page, pageSize]);

  const deleteInvoice = async (id: any) => {
    try {
      setIsLoading(true);
      const delete_customer_url = API.DELETE_INVOICE + id;
      const data: any = await DELETE(delete_customer_url);

      if (data.status) {
        notification.success({ message: "Invoice Deleted Successfully" });
        fetchInvoice(page, pageSize);
      } else {
        notification.error({
          message: "Something went wrong!! Please try again later",
        });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong!! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      dataIndex: "id",
      title: "id",
    },
    {
      dataIndex: "billNumber",
      title: "billNumber",
    },
    {
      dataIndex: "billDate",
      title: "billDate",
    },
    {
      dataIndex: "customerName",
      title: "customerName",
    },
    {
      dataIndex: "finalAmount",
      title: "finalAmount",
    },

    {
      dataIndex: "customerAddress",
      title: "customerAddress",
    },

    {
      title: "View/Edit",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/HR/Invoice/viewinvoice/${record?.id}`)}
          />
        </Space>
      ),
    },
    {
      title: "Delete",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <DeleteOutlined
            color="red"
            size={20}
            onClick={() => deleteInvoice(record?.id)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <PageHeader title="Invoice List">
        <Button onClick={() => navigate(`/HR/Invoice/createinvoice`)}>
          Create Invoice
        </Button>
      </PageHeader>
      <Card>
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            defaultPageSize: 5, // Default number of rows per page
            showSizeChanger: true, // Allows user to change the number of rows per page
            pageSizeOptions: ["2", "10", "20", "50"], // Options for page size
          }}
        />
      </Card>
    </div>
  );
}

export default InvoiceIndexHR;
